var echarts = require('echarts');
export default {
    data(){
        return {
            selected: '7',
            TotalCount:0,
            Count_C:0,
            Count_N:0,
            Count_M:0,
            Count_L:0,
            Percent:'100.00',
            Months:[],
            Months_Count:[],
            Months_Cube:[],
            Months_Weight:[],
            DatePeriod:'',
            StartDate:'',
            EndDate:'',
            From:'',
        }
    },

    mounted() {
        this.Load7Days();
        var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
                this.LoginName = user.LoginName;
            }
        this.GetTotalYear();
    },
    methods:{
        handlesearch(){
            this.DatePeriod = this.StartDate.Format("yyyy-MM-dd")+" ~ "+this.EndDate.Format("yyyy-MM-dd");
            console.log(this.DatePeriod);
            this.LoadData();
            this.GetTotalYear();
        },
        LoadChars(){
            var myChart = echarts.init(document.getElementById('echartContainer'));

            // 绘制图表
            myChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                title: { text: '' },
                animation: false,
                grid: {
                    top: 0,
                    left: 15,
                    right: 15,
                    height: 230,
                },
                xAxis: {
                    type: 'category',
                    data: this.Months,
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,
                        
                    },
                    axisLabel: {
                        inside: true,
                        formatter: '{value}\n'
                    },
                   
                },
                series: [{
                    name: '出单数量',
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: function(params) {  
                                var colorList = [ 'rgba(54, 162, 235, 0.4)',
                                'rgba(255, 206, 86, 0.4)',
                                'rgba(153, 102, 255, 0.4)',
                                'rgba(54, 162, 235, 0.4)',
                                'rgba(255, 206, 86, 0.4)',
                                'rgba(153, 102, 255, 0.4)',
                                'rgba(54, 162, 235, 0.4)',
                                'rgba(255, 206, 86, 0.4)',
                                'rgba(153, 102, 255, 0.4)',
                                'rgba(54, 162, 235, 0.4)',
                                'rgba(255, 206, 86, 0.4)',
                                'rgba(153, 102, 255, 0.4)',
                                'rgba(54, 162, 235, 0.4)',
                                                    ];
                                return colorList[params.dataIndex];
                            },
                            //  barBorderColor : 'rgba(255, 206, 86, 1)',
                           
                            barBorderWidth: 1, //边框宽度
                            label:{
                                show : true,
                                position: 'left',
                                textStyle: {
                                    fontSize: 15,
                                    color: '#666',
                                    fontStyle :'oblique',
                                },
                                formatter:function(params){
                                    var currentDt = new Date();
                                    var currMth = currentDt.Format("yyyyMM");
                                    if(params.name != currMth){
                                        return '';
                                    }
                                    else
                                    {
                                        return "出单数量: "+params.value;
                                    }
                                },
                            }
                        },
                        
                    },
                    stack: 'a',
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                //color: '#8ec6ad'
                                color:'#5bb5ea',
                            }, {
                                offset: 1,
                                color: '#ffe'
                            }])
                        }
                    },
                    data: this.Months_Count, //[5, 20, 36, 10, 10, 20]
                }]
            });
        },
        LoadChars1(){
            var myChart = echarts.init(document.getElementById('echartContainer1'));

            // 绘制图表
            myChart.setOption({
                title: { text: '' },
                animation: false,
                grid: {
                    top: 0,
                    left: 15,
                    right: 15,
                    height: 180,
                },
                dataZoom: [{
                    type: 'inside',
                    throttle: 50
                }],
                tooltip: {trigger: 'axis'},
                xAxis: {
                    type: 'category',
                    data: this.Months,
                    splitLine: {
                        show: true,
                        lineStyle:{
                             color: ['#e7e7e7'],
                             width: 1,
                            type: 'dashed'
                        }
                    },
                    axisLabel: {
                        inside: false,
                        formatter: '{value}\n'
                    },
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        inside: true
                    },
                    splitLine: {
                        show: true,
                        lineStyle:{
                             color: ['#e7e7e7'],
                             width: 1,
                                type: 'dashed',
                            }
                    },
                    axisLabel: {
                        inside: true,
                        formatter: '{value}\n'
                    },
                    z: 10,
                },
                series: [{
                    name: '重量',
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 1,
                    sampling: 'average',
                    itemStyle: {
                        normal: {
                            color: '#8ec6ad',
                            //color:'#00c6fb',
                            lineStyle:{
                                width:0.5
                            },
                            label:{
                                show:true,
                                position: 'left',
                                textStyle: {
                                    fontSize: 15,
                                    color: '#666',
                                    fontStyle :'oblique',
                                },
                                formatter:function(params){
                                    var currentDt = new Date();
                                    var currMth = currentDt.Format("yyyyMM");
                                    if(params.name != currMth){
                                        return '';
                                    }
                                    else
                                    {
                                        return "重量: "+params.value;
                                    }
                                },
                            }
                        },
                        
                    },
                    stack: 'a',
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                //color: '#8ec6ad'
                                color:'#5bb5ea',
                            }, {
                                offset: 1,
                                color: '#ffe'
                            }])
                        }
                    },
                    data: this.Months_Weight, //[5, 20, 36, 10, 10, 20]
                }]
            });
        },
        LoadChars2(){
            var myChart = echarts.init(document.getElementById('echartContainer2'));

            // 绘制图表
            myChart.setOption({
                title: { text: '' },
                animation: false,
                grid: {
                    top: 0,
                    left: 15,
                    right: 15,
                    height: 180,
                },
                dataZoom: [{
                    type: 'inside',
                    throttle: 50
                }],
                tooltip: {trigger: 'axis'},
                xAxis: {
                    type: 'category',
                    data: this.Months,
                    splitLine: {
                        show: true,
                        lineStyle:{
                             color: ['#e7e7e7'],
                             width: 1,
                            type: 'dashed'
                        }
                    },
                    axisLabel: {
                        inside: false,
                        formatter: '{value}\n'
                    },
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        inside: true
                    },
                    splitLine: {
                        show: true,
                        lineStyle:{
                             color: ['#e7e7e7'],
                             width: 1,
                                type: 'dashed',
                            }
                    },
                    axisLabel: {
                        inside: true,
                        formatter: '{value}\n'
                    },
                    z: 10,
                },
                series: [{
                    name: '体积',
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 1,
                    sampling: 'average',
                    itemStyle: {
                        normal: {
                            color: '#8ec6ad',
                            //color:'#00c6fb',
                            lineStyle:{
                                width:0.5
                            },
                            label:{
                                show:true,
                                position: 'left',
                                textStyle: {
                                    fontSize: 15,
                                    color: '#666',
                                    fontStyle :'oblique',
                                },
                                formatter:function(params){
                                    var currentDt = new Date();
                                    var currMth = currentDt.Format("yyyyMM");
                                    if(params.name != currMth){
                                        return '';
                                    }
                                    else
                                    {
                                        return "体积: "+params.value;
                                    }
                                },
                            }
                        },
                        
                    },
                    stack: 'a',
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                //color: '#8ec6ad'
                                color:'#5bb5ea',
                            }, {
                                offset: 1,
                                color: '#ffe'
                            }])
                        }
                    },
                    data: this.Months_Cube, //[5, 20, 36, 10, 10, 20]
                }]
            });
        },
        LoadSelectedData(){
            if(this.selected =="7"){
                this.Load7Days();
            }
            else if(this.selected =="30"){
                this.Load30Days();
            }
            else if(this.selected =="90"){
                this.Load90Days();
            }
        },
        Load7Days(){
            this.LoadDays(7);
        },
        Load30Days(){
            this.LoadDays(30);
        },
        Load90Days(){
            this.LoadDays(90);
        },
        LoadDays(days){
            this.EndDate = new Date();
            this.StartDate = (new Date()).addDays(-days);
            
            this.DatePeriod = this.StartDate.Format("yyyy-MM-dd")+" ~ "+this.EndDate.Format("yyyy-MM-dd");
            console.log(this.DatePeriod);
            this.LoadData();
            this.GetTotalYear();
        },
        LoginOut(){
            localStorage.removeItem('CurrentUser');
            localStorage.removeItem('CurrentUserPwd');
            
            sessionStorage.removeItem('user');
            this.$router.push('/Login');
        },
        LoadData(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getLogsMethod = 'TransLog_Mobile/gettransanaysisinfo';
            var curDate = new Date();
            
            this.$axios.get(getLogsMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName, 
                        'DeveliverDtFrom': this.StartDate.Format("yyyy-MM-dd"),
                        'DeveliverDtTo':this.EndDate.Format("yyyy-MM-dd"),
                    }
                })
            .then((response) => {
                    if(response.data.IsSuccess)
                    {
                        me.TotalCount = response.data.Data.TotalCount;
                        me.Count_C = response.data.Data.Count_C;
                        me.Count_M = response.data.Data.Count_M;
                        me.Count_L = response.data.Data.Count_L;
                        me.Count_N = response.data.Data.Count_N;
                        me.Percent = response.data.Data.Percent;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                       me.alert(strMsg);
                    }
            })
            .catch(function (error) {
                me.alert(error);
            });
        },

        GetTotalYear(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getLogsMethod = 'TransLog_Mobile/gettransmthanaysisinfo';
            var curDate = new Date();
            var startDate = (new Date()).addYears(-1);
            this.$axios.get(getLogsMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName, 
                        'DeveliverDtFrom':startDate.Format("yyyy-MM-dd"),
                        'DeveliverDtTo': curDate.Format("yyyy-MM-dd"),
                    }
                })
            .then((response) => {
                    if(response.data.IsSuccess)
                    {
                        var length = response.data.Data.length;
                        this.Months = [length];
                        this.Months_Count = [length];
                        this.Months_Cube = [length];
                        this.Months_Weight = [length];
                        for(var i=0;i<response.data.Data.length;i++)
                        {
                            this.Months[i] = response.data.Data[i].Month;
                            this.Months_Count[i] = response.data.Data[i].TotalCount;
                            this.Months_Cube[i] = parseFloat(Number(response.data.Data[i].TotalCube).toFixed(2));
                            this.Months_Weight[i] = parseFloat(Number(response.data.Data[i].TotalWeight).toFixed(2)); //response.data.Data[i].TotalWeight;
                        }

                        this.LoadChars();
                        this.LoadChars1();
                        this.LoadChars2();
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                       me.alert(strMsg);
                    }
            })
            .catch(function (error) {
                me.alert(error);
            });
        },

        GOTOList(status)
        {
            var sDeveliverDtFrom  = this.StartDate.Format("yyyy-MM-dd");
            var sDeveliverDtTo = this.EndDate.Format("yyyy-MM-dd");

            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            this.$router.push({ name: user.MobileList, query: { 
                GoodsStatus:status,
                DeveliverDtFrom: sDeveliverDtFrom,
                DeveliverDtTo:sDeveliverDtTo,
                TokenId: user.TokenId
                 },meta:{keepAlive:false}})
        },

        GOTOCount_M(){
            this.GOTOList('少货');
        },
        GOTOCount_L(){
            this.GOTOList('多货');
        },
        GOTOCount_N(){
            this.GOTOList('未签收');
        },
        GOTOCount_C(){
            this.GOTOList('无异常');
        },

        handleChange(index) {
          }
    }
}


// WEBPACK FOOTER //
// ./src/components/PeriodSummary/PeriodSummary.js